import React from 'react';
import Helmet from 'react-helmet';

import Navbar from '../../components/navbar/navbar';
import MainLayout from '../../layouts/layout';
import Para1 from '../../components/typographies/para1';
import Para2 from '../../components/typographies/para2';
import Header1 from '../../components/typographies/header1';
import SuperHeader from '../../components/typographies/superheader';
import ArticleListItem from '../../components/article/articleListItem';

import '../../styles/article.scss';

export default class ArticleList extends React.Component {
  render(){
    return (
      <MainLayout key="main-layout">
        <Helmet>
          <title>Product, Design & The Process</title>
          <meta name="description" content="We write about everything Product, everything from conception to execution" />
          <meta property="og:url" content="https://surebro.com/articles" />
          <meta property="og:title" content="Product, Design & The Process" />
          <meta property="og:description" content="We write about everything Product, everything from conception to execution" />
          <meta property="og:image" content="https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png" />
        </Helmet>
        <Navbar key="navbar" active={4} className="red" />
        <div className="container">
          <div className="Article-hero">
            <div className="row">
              <div>
                <SuperHeader
                    key="about-title"
                    className="text-left darkgrey About-content-title"
                    text="Product, Design & The Process"
                />
              </div>
            </div>
          </div>
          <Para1 className="grey" text="Recent Articles" />
          <div className="Article-list">
            <ArticleListItem
              title="How about a debt clearing sprint?"
              link="articles/how-about-clearing-your-debts"
              date="Jul 4th, 2018"
              target=""
              tags={['opinion','idea']}
            />
            <ArticleListItem
              title="Let’s talk about MVP"
              link="https://blog.surebro.com/minimal-viable-product-8fa5f24e58c8"
              date="Jun 7, 2016"
              target="__blank"
              tags={['idea']}
            />
            <ArticleListItem
              title="What’s “The box” in “Think outside the box”?"
              link="https://blog.surebro.com/what-s-the-box-in-think-outside-the-box-5373f76ccc95"
              date="Jan 29th, 2016"
              target="__blank"
              tags={['musings']}
            />
            <ArticleListItem
              title="Burning Capital for Dummies"
              link="https://blog.surebro.com/burning-capital-for-dummies-bec7831eb278"
              date="Dec 20th, 2015"
              target="__blank"
              tags={['how-to']}
            />
          </div>
        </div>
      </MainLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/articles/index.js